<!-- PWA安装弹窗 -->
<template>
  <ion-modal mode="md" :is-open="visible" id="modal-install-download" :backdrop-dismiss="false">
    <div class="w-80 bg-white text-black py-5 px-[.625rem] mx-auto rounded-2xl">
      <div class="flex flex-col items-center" >
        <div class="flex items-center">
          <ion-img class="w-7 mr-1.5" src="/icons/ic_raid_install.png"/>
          <p class="text-[1.75rem]">{{ $t('viewsSystem.downloadIndex01') }}</p>
        </div>
        <p class="text-lg text-[#666] border border-[#747475] leading-tight px-3 rounded-[.1875rem] mt-2.5">{{ $t('viewsSystem.downloadIndex02') }}</p>
        <div class="flex items-center bg-[#0287601A] border border-[#028760] rounded-full px-3 my-5">
          <ion-img class="w-4 mr-1.5" src="/icons/ic_actived.png"/>
          <p class="text-xl text-[#028760] leading-tight">{{ $t('viewsSystem.downloadIndex03') }}</p>
        </div>
        <!-- 安装按钮 -->
        <div class="w-full px-10" v-if="checked">
          <div class="w-full" v-if="installStatus === 0 || os === 'DesktopOS'">
            <button class="install" v-if="pwaLaunchAllow" @click="launchCheck">{{ $t('label.launchApp') }}</button>
            <button class="install" v-else-if="pwaAllow" @click="installCheck()">{{ $t('viewsSystem.install') }}</button>
            <button class="install" v-else @click="downLoadCheck">{{ $t('viewsSystem.downloadIndex04') }}</button>
          </div>
          <!-- 安装进度中 -->
          <div class="relative w-60" v-if="installStatus === 1">
            <ion-progress-bar class="h-[2.8125rem] rounded-full" :value="installProgress" color="success"/>
            <p class="absolute w-full h-full text-center leading-[2.8125rem] top-0 left-0">{{ `${(installProgress * 100).toFixed(0)}%` }}</p>
          </div>
          <!-- 安装进度完成 -->
          <ion-button mode="md" class="flex-1 text-white w-60" shape="round" v-if="installStatus === 2">
            <button class="w-full h-full" @click="launchCheck">{{ $t('label.launchApp') }}</button>
          </ion-button>
        </div>
        <!-- 检测环境进度条 -->
        <div class="flex justify-center relative w-11 h-11" v-else>
          <ion-spinner name="crescent" class="absolute w-full h-full"/>
          <div class="absolute w-full h-full flex justify-center items-center text-xs">{{ progress }}%</div>
        </div>
      </div>
    </div>
  </ion-modal>
</template>

<script setup lang="ts">
import { useAppStore } from '@/store/app';
import { computed, ref, watch } from 'vue';
import { useSystemStore } from '@/store/system';
import { launchCheck } from '@/utils/pwa/launch';
import { useChannelStore } from '@/store/channel';
import { installCheck } from '@/utils/pwa/install';
import { downLoadCheck } from '@/utils/pwa/downLoad';
import { IonModal, IonImg, IonProgressBar, IonButton, IonSpinner } from '@ionic/vue';
import i18n from '@/i18n';

const { t } = i18n.global // 国际化

const appStore = useAppStore();         // 应用信息
const systemStore = useSystemStore();   // 系统信息
const channelStore = useChannelStore(); // 渠道信息

interface Props {
  visible?: boolean;
  checking?: boolean;
}

const props = defineProps<Props>();

const progress = ref(0);        // 安装进度
const checked = ref(false);     // 是否检测完成
const installProgress = ref(0); // 安装进度

const os = computed(() => systemStore.app?.build || '');                            // 系统类型
const unStandalone = computed(() => appStore.unStandalone);                         // 是否未在PWA中运行且可以安装PWA
const pwaLaunchAllow = computed(() => appStore.pwaLaunchAllow);                     // 是否允许PWA启动
const installStatus = computed(() => channelStore.installStatus);                   // 安装状态
const pwaAllow = computed(() => systemStore.isPwaVisible && appStore.unStandalone); // 是否允许PWA安装

// 监听安装状态
watch(() => installStatus.value, (val) => {
  if (val === 1) {
    const timer = setInterval(() => {
      if (installProgress.value < 1) {
        installProgress.value += 0.01;
      } else {
        installProgress.value = 1;
        channelStore.setInstallStatus(2);
        clearInterval(timer);
      }
    }, 120);
  }
})
// 监听检测状态
watch(() => props.checking, (val) => {
  if (val) {
    const checkTimer = setInterval(() => {
      if (progress.value < 100) {
        const installButton = document.querySelector('.progressier-install-button');  // 使用querySelector获取按钮元素
        const buttonText = installButton?.textContent;                                // 获取按钮的当前文本内容
        if (unStandalone.value || buttonText == t('label.launchApp')) {               // 判断是否可以安装PWA或按钮文本内容是否为'打开应用'
          progress.value += 2;
        } else {
          progress.value += 1;
        }
      } else {
        checkPawInstallButton();
        progress.value = 100;
        checked.value = true;
        clearInterval(checkTimer);
      }
    }, 60);
  }
})

/**
 * @description 检查Paw安装按钮
 */
function checkPawInstallButton() {
  const installButton = document.querySelector('.progressier-install-button');  // 使用querySelector获取按钮元素
  const buttonText = installButton?.textContent;                                // 获取按钮的当前文本内容
  if (buttonText == t('label.launchApp'))                                       // 判断按钮文本内容是否为'打开应用'
    appStore.setPwaLaunchAllow(true);                                           // 设置PWA启动允许
}
</script>

<style scoped>
ion-modal#modal-install-download::part(content){
  --height: fit-content;
}

ion-button {
  --background: linear-gradient(180deg, #72CB45 0%, #337611 100%);
  min-height: 2.8125rem;
}

button.install {
  background: #01875f;
  color: white;
  border-radius: .5rem;
  width: 100%;
  height: 2.8125rem;
}
</style>
